import Typography from 'typography';

const fontFamily = '"Raleway", Helvetica, Arial, sans-serif';
const ReindexTypography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: '22.5px',
  bodyFontFamily: fontFamily,
  headerFontFamily: fontFamily,
  bodyWeight: 300,
  headerWeight: 500,
  boldWeight: 500,
  modularScales: [
    'minor third',
  ],
  googleFonts: [
    {
      name: 'Raleway',
      styles: ['200', '300', '500'],
    },
    {
      name: 'PT Sans',
      styles: ['400'],
    },
  ],
});

export default ReindexTypography;



/** WEBPACK FOOTER **
 ** ./ui/_ReindexTypography.jsx
 **/